if (!customElements.get('logo-color-picker')) {
  class LogoColorPicker extends HTMLElement {
    connectedCallback() {
      this.preview = this.querySelector('[data-logo-color-image]');
      this.chip = this.querySelector('[data-logo-color-chip]');
      this.input = this.querySelector('[data-logo-color-input]');
      this.label = this.querySelector('[data-logo-color-selected-label]');
      this.buttons = Array.from(this.querySelectorAll('[data-logo-color-swatch]'));

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.select(button));
      });

      this.syncChipFromBarrel();
      document.addEventListener('caliburn:color-swatch-change', (event) => {
        if (event.detail && event.detail.propertyKey === 'Barrel Color') {
          this.setChipColor(event.detail.hex);
        }
      });
    }

    syncChipFromBarrel() {
      const barrelSwatch = document.querySelector(
        'color-property-picker[data-property-key="Barrel Color"] [aria-pressed="true"]'
      );
      if (barrelSwatch) {
        this.setChipColor(barrelSwatch.style.getPropertyValue('--swatch-color').trim());
      }
    }

    setChipColor(hex) {
      if (this.chip && hex) this.chip.style.setProperty('background', hex);
    }

    select(button) {
      this.buttons.forEach((b) => b.setAttribute('aria-pressed', 'false'));
      button.setAttribute('aria-pressed', 'true');

      const value = button.getAttribute('data-logo-color-swatch');
      const hex = button.getAttribute('data-logo-color-hex');
      if (this.preview && hex) this.preview.style.setProperty('--logo-color', hex);
      if (this.input) this.input.value = value;
      if (this.label) this.label.textContent = value;

      this.dispatchEvent(new CustomEvent('caliburn:logo-color-change', {
        bubbles: true,
        detail: { label: value, hex },
      }));
    }
  }

  customElements.define('logo-color-picker', LogoColorPicker);
}
